/**
 * Include your custom JavaScript here.
 *
 */
(function () {
  'use strict';

  function formatSavingsMoney(cents, box) {
    var amount = Number(cents) / 100;
    var locale = document.documentElement.lang || 'pt-BR';
    var currency = box.dataset.currency || 'BRL';
    var currencyDisplay = box.dataset.currencyDisplay || 'symbol';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        currencyDisplay: currencyDisplay
      }).format(amount);
    } catch (error) {
      return currency + ' ' + amount.toFixed(2).replace('.', ',');
    }
  }

  function updateSavingsBox(box, variant) {
    if (!box || !variant) {
      return;
    }

    var currentPrice = Number(variant.price || 0);
    var comparePrice = Number(variant.compare_at_price || 0);
    var savings = comparePrice - currentPrice;
    var hasSavings =
      comparePrice > currentPrice &&
      savings > 0 &&
      Number.isFinite(savings);

    box.hidden = !hasSavings;

    if (!hasSavings) {
      return;
    }

    var valueElement = box.querySelector('[data-product-savings-value]');

    if (valueElement) {
      valueElement.textContent = formatSavingsMoney(savings, box);
    }
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;

    if (!variant) {
      return;
    }

    var eventTarget = event.target;
    var productSection =
      eventTarget instanceof Element
        ? eventTarget.closest('[data-section-type="product"]')
        : null;

    var scope = productSection || document;

    scope.querySelectorAll('[data-product-savings]').forEach(function (box) {
      updateSavingsBox(box, variant);
    });
  });
})();